import { SpaceInfoItemType } from '~src/spacesPlatform/models/ContentType';
import { IExplorableItemTypeInfo, INamedItemInfo, IProjectItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';

interface IViewConent extends IView {
  contentType: SpaceInfoItemType;
}
export interface IAccelerationTaskInfo
  extends IExplorableItemTypeInfo, IProjectItemInfo {
  workbook: INamedItemInfo;
  owner: IUser;
  view: IViewConent;
  name: string;
  luid: string;
  lastMonthViewCount: number;
  avgLoadTimeWithMaterializationInSec: string;
  avgLoadTimeWithoutMaterializationInSec: string;
  lastMonthViewCountMax: number;
  lastMonthJobAvgTimeInSec: number;
  lastMonthJobCount: number;
  // adminDisabled will be used to decide if the Resume/Suspend Acceleration button is clickable
  disallowed: boolean;
  // accelerationStatus will be used to build the column, in which only a field name can accepted,
  // so a separate field is declared here
  accelerationStatus: string;
  estimatedDiskUsageKb: number;
  updatedAt: string;
}

/*
* AccelerationStatus values matches with the backend states and below are the references for additional information.
* Status Mapping Reference: DataAccelerationSortAndFilterHelper class and appendQueryForAccelerationStatusFilterClause method in Java Backend Code.
* Query Reference: getAccelerationInfoForNotDisabledViews method of MaterializedViewsJobStatsDaoJpa class
* workgroup/src/silos/tableau-server/interfaces/tab-domain-materializedviews-interfaces/src/com/tableausoftware/domain/materializedviews/service/IMaterializedViewService.AdminAccelerationStatus
*/
export enum AdminAccelerationStatus {
  // Suspended corresponds to admin disallowed or suspended status
  SUSPENDED = 'Suspended',
  // Active corresponds to Materialized status
  ACTIVE = 'Active',
  // Pending corresponds to Job Submitted or Enabled status
  PENDING = 'Pending',
  // Error corresponds to Job Failed or Materialization Not useful status
  ERROR = 'Error',
  // Unknown corresponds to unrecognized state from database
  UNKNOWN = 'Unknown',
  // SystemSuspended corresponds to system suspended status
  SYSTEM_SUSPENDED = 'SystemSuspended',
  // Recommended status corresponds to the views which are recommended by the recommendation Engine
  RECOMMENDED = 'Recommended',
  // No queries were materialized in the previous acceleration jobs
  ACCELERATION_NOT_USEFUL = 'AccelerationNotUseful',
  // The previous acceleration job was skipped due to resource constraint, most likely due to the max daily jobs
  SKIPPED_DUE_TO_RESOURCE_CONSTRAINT = 'SkippedDueToResourceConstraint',
  // Automatically Accelerated state
  AUTO_ACCELERATED = 'AutoAccelerated'
}
